export const ADD_TO_DISLIKE = 'ADD_TO_DISLIKE';
export const REMOVE_FROM_DISLIKE = 'REMOVE_FROM_DISLIKE';
export const CLEAR_DISLIKE = 'CLEAR_DISLIKE';